var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRow = void 0;
var TableRow_1 = __importDefault(require("./TableRow"));
exports.TableRow = TableRow_1.default;
exports.default = TableRow_1.default;
//# sourceMappingURL=index.js.map